import { StyleProvider } from "@ant-design/cssinjs";
import { App as AntApp, ConfigProvider } from "antd";
import ruRU from "antd/es/locale/ru_RU";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { antdUz } from "@/app/i18n/antd-uz";
import { skudDarkTheme, skudTheme } from "./theme";
import { useColorScheme } from "./useColorScheme";

interface AntdProviderProps {
	children: ReactNode;
}

/**
 * ⚠️ Tema obyekti bu yerda INLINE yozilmaydi — u `theme.ts` da va
 * `theme.test.ts` bilan qulflangan (o'sha fayl izohiga qarang).
 *
 * ⚠️ Tanlov `useColorScheme()` dan (P2 spec §4) — `document.dataset.theme`
 * ni ham shu hook boshqaradi, ya'ni Tailwind `dark:` varianti va xarita
 * CSS o'zgaruvchilari (§5, §6) `ConfigProvider` bilan sinxron qoladi.
 *
 * ⚠️ Til `useColorScheme()` bilan bir xil naqshda — lekin bu yerda
 * `useTranslation()`ning `i18n` obyektidan (P7 spec §7). `AntdProvider`
 * `../i18n/index.ts` (glob'li ishga tushirish moduli) ni IMPORT QILMAYDI —
 * `./index.ts` faylidagi izohga qarang: bu komponent `NotFoundRoute.test.tsx`
 * kabi router konteksti bo'lmagan testlarda ham render qilinadi, `i18next`
 * paketining o'zi esa (main.tsx orqali) initsializatsiya qilinmagan bo'lsa
 * ham `i18n.language` xatosiz `undefined` qaytaradi — standart holatda
 * `ruRU` tanlanadi, bu ilova standarti (`DEFAULT_LOCALE = "ru"`) bilan mos.
 */
export function AntdProvider({ children }: AntdProviderProps) {
	const { scheme } = useColorScheme();
	const {
		i18n: { language },
	} = useTranslation();

	return (
		<StyleProvider layer>
			<ConfigProvider
				theme={scheme === "dark" ? skudDarkTheme : skudTheme}
				locale={language === "uz" ? antdUz : ruRU}
			>
				<AntApp>{children}</AntApp>
			</ConfigProvider>
		</StyleProvider>
	);
}
